import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Worksheet } from '../../api/models/worksheet';
import { DeleteModalComponent } from '../delete-modal/delete-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../api/services/project.services';
import { AuthService } from '../../api/services/auth.service';
import { TaskConfirmationDialogComponent } from '../dashboard-my-oasis/project-order-summary/task-confirmation-dialog/task-confirmation-dialog.component';
import { Task } from '../../api/models/task';
import { UserService } from '../../api/services/user.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { UserInfo } from '../../api/models/user-model';
import { Subject } from 'rxjs/Subject';
import { ProjectOrderInput } from '../../api/models/project-summary';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { TasksService } from '../../api/services/tasks.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss']
})
export class OrderTableComponent implements OnInit
{

  @Input()
  set data(obs: Observable<Worksheet[]>) {
    obs.subscribe((items) => {
      this.allOrders = items;
      this.orderItems = this.allOrders;
      this.getUserIds();
      this.getApprovers();
      this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
    });
  }

  @Input() projectId: string;
  @Input() projectName: string;
  @Input() accountNumber: string;
  @Input() verizonFlag: boolean = false;
  @Input() projectStatus: boolean = true;

  @Input() healthFlag: boolean = false;
  @Input() editFlag: boolean = false;
  @Input() subTotalFlag: boolean = false;

  constructor(private router: Router,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private authService: AuthService,
    private userService: UserService,
    private preferencesService: PreferencesService,
    private taskService: TasksService,
    private toastr: ToastrService
  ) { }

  orderItems = [];
  allOrders = [];
  myOrders = [];
  orderItemsFiltered = [];
  orderItemsSelected = [];
  orderItemsToShow = [];
  ordersUserIds = [];
  userInfo: UserInfo[] = [];
  visibleContext: boolean = false;
  

  pageSize = 50;
  page = 1;

  toggleOrderRow = {};

  approverFilters = [];
  orderType = [{display: 'All orders', value: 'all'}, {display: 'My Orders', value: 'myOrders'}];
  kindFilterSelected: 'Order' | 'Quote' | 'Worksheet' = 'Worksheet';
  approverFilterSelected = 'all';
  currentOption = 'all';
  confirmedOrder = {};
  @Input() $updateErrorMessageSubject = new Subject<string>();

  @Output() updateTasksCount: EventEmitter<any> = new EventEmitter();

  permissionLoaded: Promise<boolean>;
  roleRequest: RoleRequest;
  isTesscoAdmin: boolean = false;
  isClientAdmin: boolean = false;
  userTeamType: number = null;

  orderCount: number = 0;
  quoteCount: number = 0;
  worksheetCount: number = 0;

  getUserIds() {
    this.allOrders.forEach(order => {
      if (!this.ordersUserIds.includes(order.initiatorId) && order.initiatorId) {
        this.ordersUserIds.push(order.initiatorId);
      }
      if (!this.ordersUserIds.includes(order.approvalAuthorityUserId) && order.approvalAuthorityUserId) {
        this.ordersUserIds.push(order.approvalAuthorityUserId);
      }
      if (!this.ordersUserIds.includes(order.modifiedUserId) && order.modifiedUserId) {
        this.ordersUserIds.push(order.modifiedUserId);
      }
    });
    if (this.ordersUserIds && this.ordersUserIds.length > 0) {
      this.userService.getUserDisplayNames(this.ordersUserIds).subscribe(result => {
        this.userInfo = result;
      });
    }

  }

  getName(userId: string) {
    const info = this.userInfo.find(u => u.userId === userId);
    if (info) {
      return info.displayName;
    } else {
      return 'N/A';
    }
  }

  expandOrCollapseOrder(orderId: string) {
    this.toggleOrderRow[orderId] = (this.toggleOrderRow[orderId] === undefined) ? true : !this.toggleOrderRow[orderId];
  }

  calculatePermissions(requiredRoles: string[], context?: string) {
    if (context === 'MARKET') {
      this.preferencesService.getPreferences('USER', this.authService.getUserId())
        .subscribe(prefs => {
          const currentMarket = prefs['current-market'].Value;
          this.authService.getUserRolesInContext(`${context}~${currentMarket}`).subscribe(roles => {
            this.visibleContext = requiredRoles.every(r => roles.includes(r));
            this.permissionLoaded = Promise.resolve(true);
          });
        });
    } else {
      this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
        const con = `ORGANIZATION~${user['Organization ID']}`;
        this.authService.getUserRolesInContext(con).subscribe(roles => {
          this.visibleContext = requiredRoles.every(r => roles.includes(r));
          this.permissionLoaded = Promise.resolve(true);
        });
      });
    }
  }

  loadPage(page) {
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.orderItemsToShow = this.orderItemsFiltered.slice(from, to);
  }

  deleteWorksheet(worksheet: Worksheet) {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the Worksheet <strong>${ worksheet.siteName }</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.projectService.deleteWorksheet(worksheet.id).subscribe(() => {
        modalRef.close();

      modalRef.result.then(() => {
        this.orderItems = this.orderItems.filter(o => o.id !== worksheet.id);
        this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
        this.loadPage(this.page);
        this.onUpdateSuccess("Worksheet deleted successfully");
      }
      ).catch();
      }, error => {
        modalRef.close();
        this.$updateErrorMessageSubject.next(error.error.message);
      });
    };
  }

  filterMyOrders(option: string) {
    if (option === 'all') {
      this.currentOption = 'all';
      this.orderItems = this.allOrders;
      this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
    } else {
      this.currentOption = option;
      this.myOrders = this.allOrders.filter(item => item.createdBy == this.authService.getUserId());
      this.orderItems = this.myOrders;
      this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
      /* if (this.projectId) {
        this.projectService.getMyOrders(this.projectId, this.authService.getUserId()).subscribe(orders => {
          this.myOrders = orders.filter(item => item.createdBy == this.authService.getUserId());
          this.orderItems = this.myOrders;
          this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
        });
      } */
    }
  }

  filterByApprover(approver: string) {
    this.approverFilterSelected = approver;
    this.applyCurrentFilters(approver, this.kindFilterSelected);
  }

  filterByKind(kind: 'Order' | 'Quote' | 'Worksheet') {
    this.kindFilterSelected = kind;
    this.applyCurrentFilters(this.approverFilterSelected, kind);
  }

  applyCurrentFilters(approver: string, kind: 'Order' | 'Quote' | 'Worksheet') {
    if (kind === 'Order') {
      this.orderItemsFiltered = this.orderItems.slice()
        .filter(i => i.orderNumber || i.orderNumber === '')
        .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver);
    } else if (kind === 'Quote') {
      this.orderItemsFiltered = this.orderItems.slice()
        .filter(i => i.quoteNumber && (i.orderNumber === undefined || i.orderNumber === null || i.orderNumber === ''))
        .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver);
    } else if (kind === 'Worksheet') {
      this.orderItemsFiltered = this.orderItems.slice()
        .filter(i => !i.quoteNumber && (i.orderNumber === undefined || i.orderNumber === null || i.orderNumber === ''))
        .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver);
    }
    this.orderCount = this.orderItems.filter(i => i.orderNumber || i.orderNumber === '')
      .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver).length;
    this.quoteCount = this.orderItems
      .filter(i => i.quoteNumber && (i.orderNumber === undefined || i.orderNumber === null || i.orderNumber === ''))
      .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver).length;
    this.worksheetCount = this.orderItems
      .filter(i => !i.quoteNumber && (i.orderNumber === undefined || i.orderNumber === null || i.orderNumber === ''))
      .filter(i => approver === 'all' ? true : i.approvalAuthorityUserId === approver).length;
    this.loadPage(this.page);
  }

  formatStatus(status: string): string {
    if (status === 'NONE') {
      return "Incomplete";
    } else if (status === 'PENDING_APPROVAL') {
      return "Pending Approval";
    } else if (status === 'DENIED') {
      return "Revision Requested by Approver";
    } else if (status === 'QUOTED_AWAITING_PO') {
      return "Quoted, awaiting PO";
    } else if (status === 'ORDER_PLACED') {
      return "Order Placed"
    } else if (status === 'TESSCO_REVIEW_COMPLETE') {
      return "TESSCO Review Complete";
    } else {
      return status.charAt(0) + status.substr(1).toLowerCase();
    }
  }

  formatVerizonStatus(status: string): string {
    if (status === 'NONE') {
      return 'Incomplete';
    } else if (status === 'PENDING_APPROVAL') {
      return 'Pending Approval';
    } else if (status === 'TESSCO_REVIEW') {
      return "TESSCO Review";
    } else if (status === 'DENIED_BY_TESSCO') {
      return "Revision Requested by TESSCO";
    } else if (status === 'DENIED') {
      return "Revision Requested by Approver";
    } else if (status === 'TESSCO_REVIEW_COMPLETE') {
      return "TESSCO Review Complete";
    } else if (status === 'QUOTED_AWAITING_PO') {
      return "Quoted, awaiting PO";
    } else {
      return status.charAt(0) + status.substr(1).toLowerCase();
    }
  }

  getApprovers() {
    this.orderItems.forEach(order => {
      if ((order.approvalStatus === 'APPROVED' || order.approvalStatus === 'DENIED'
          || order.approvalStatus === 'TESSCO_REVIEW' || order.approvalStatus === 'DENIED_BY_TESSCO'
          || order.approvalStatus === 'TESSCO_REVIEW_COMPLETE')
          && order.approvalAuthorityUserId) {
        if (!this.approverFilters.includes(order.approvalAuthorityUserId)) {
          this.approverFilters.push(order.approvalAuthorityUserId);
        }
      }
    });
  }

  openItem(order: Worksheet) {
    if (!order.busy && this.projectStatus) {
      if (!order.isQuoted && (order.orderNumber === undefined || order.orderNumber === null)) {
        this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', order.id] } }]);
      } else if (order.orderNumber === undefined || order.orderNumber === null) {
        this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['checkout', order.id] } }]);
      } else {
        this.routeToOrderConfirmationOrOrdersPage(order);
      }
    }
  }

  private routeToOrderConfirmationOrOrdersPage(order: Worksheet) {
    this.projectService.getOrderConfirmationV2(new ProjectOrderInput(this.projectName, this.accountNumber, order.orderNumber, localStorage.getItem("marketLocationCode"))).subscribe(result => {
      this.confirmedOrder = result.orders[0];
      if (this.confirmedOrder && this.projectName && this.accountNumber) {
        this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-confirmation', this.projectName, this.accountNumber, order.orderNumber] } }]);
      } else {
        this.router.navigate(['/quote-process', { outlets: { 'quote-process-content': ['confirmedOrder', order.id] } }]);
      }
    });
  }

  openTaskDialog(task: Task, orderSelected: Worksheet) {
    if (this.projectStatus) {
      if (task.taskType === 'CABLE CUT') {
        this.projectService.getBomLines(orderSelected.bomId).subscribe(lines => {
          const modalRef = this.modalService.open(TaskConfirmationDialogComponent, {
            backdrop: 'static',
            keyboard: false
          });
          modalRef.componentInstance.task = task;
          modalRef.componentInstance.line = lines.find(line => line.id === task.bomLineID);
          modalRef.result.then(result => {
            result && this.cleanOrderTasks(orderSelected.id, task);
            this.taskService.refreshTasksCount.next(true);
          }).catch(() => { 
            // Empty catch block
          });
        });
      } else if (task.taskType === 'RECEIPT OF GOODS') {
        this.routeToOrderConfirmationOrOrdersPage(orderSelected);
      } else {
        const modalRef = this.modalService.open(TaskConfirmationDialogComponent, {
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.order = orderSelected;
        modalRef.componentInstance.task = task;
        modalRef.result.then(result => {
          result && this.cleanOrderTasks(orderSelected.id, task);
          this.taskService.refreshTasksCount.next(true);
        }).catch(() => { 
          // Empty catch block
        });
      }
    }
  }

  cleanOrderTasks(orderId: string, taskCleaned: Task) {
    const order = this.orderItems.find(o => o.id === orderId);
    order.tasks = order.tasks.filter(t => {
      if (t['taskType'] === 'CABLE CUT') {
        return t['bomLineID'] !== taskCleaned['bomLineID'];
      } else {
        return t['taskType'] !== taskCleaned['taskType']
      }
    });
    if (!order.tasks.length) {
      delete order.tasks;
    }
    this.updateTasksCount.emit();
    this.applyCurrentFilters(this.approverFilterSelected, this.kindFilterSelected);
  }

  ngOnInit() {
    // this.calculatePermissions(['WORKSHEET_DELETE']);
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
    forkJoin(this.userService.findUserById(this.authService.getUserId()),
      this.authService.getUserRoles(this.roleRequest)).subscribe(result => {
        let user = result[0];
        const roleMap = result[1];
        this.isTesscoAdmin = roleMap.getRoleMap('ADMIN_TESSCO');
        this.isClientAdmin = roleMap.getRoleMap('ADMIN_CLIENT');

        if (user['Team ID']) {
          this.authService.getTeamById(user['Team ID']).subscribe(team => {
            this.userTeamType = team.type;
            this.permissionLoaded = Promise.resolve(true);
          });
        } else {
          this.permissionLoaded = Promise.resolve(true);
        }
      });
  }

  compareNumbers(x, y, desc?: boolean) {
    return desc ? Number(x) < Number(y) : Number(x) > Number(y);
  }

  compareStrings(a, b, desc?: boolean) {
    return desc ? a.toLowerCase() < b.toLowerCase() : a.toLowerCase() > b.toLowerCase();
  }

  sortTable(n: number) {
    let table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    table = document.getElementById('orderTable');
    switching = true;
    dir = 'asc';

    const compareFunction = n === 5 ? this.compareNumbers : this.compareStrings;

    while (switching) {
      switching = false;
      rows = table.rows;

      for (i = 1; i < (rows.length - 1); i++) {
        shouldSwitch = false;
        x = rows[i].getElementsByTagName('TD')[n].innerHTML;
        y = rows[i + 1].getElementsByTagName('TD')[n].innerHTML;

        if (compareFunction(x, y, dir === 'desc')) {
          shouldSwitch = true;
          break;
        }
      }

      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switchcount++;
      } else if (switchcount === 0 && dir === 'asc') {
        switching = true;
        dir = 'desc';
      }
    }
  }

  openActivityLog(worksheetId: string) {
    this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-activity-log', worksheetId] } }]);
  }

  editWorksheetByTesscoAdmin(order: Worksheet) {
    if (this.isTesscoAdmin) {
      if (!order.busy) {
        this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['order-worksheet', order.id] } }]);
      }
    }
  }

  checkForDeleteWorksheetPermission(order: Worksheet) {
    if (this.isTesscoAdmin || this.isClientAdmin) {
      return true;
    } else {
      switch (this.userTeamType) {
        case 0: // for initators
          if (this.authService.getUserId() == order.createdBy) {
            return true;
          } else {
            return false;
          }
        case 1: // for approvers
          return true;
        default:
          if (order.approvalStatus == 'NONE') {
            return true;
          } else {
            return false;
          }
      }
    }
  }

  private onUpdateSuccess(successsMessage) {
    this.toastr.success(successsMessage, 'OK!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-table/order-table.component.ts